import Config from '../../config/Config'
import { map, mergeMap, catchError, withLatestFrom } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { of } from 'rxjs'
import { ajax } from 'rxjs/ajax'
import * as actions from './actions'
import * as authSelectors from '../auth/selectors'
const queryString = require('@promoboxx/query-string-babel')

const buildRetailerAccountParams = (payload) => {
  const { fields } = payload

  let params = queryString.stringify(
    {
      fields,
    },
    { arrayFormat: 'bracket' },
  )
  if (params) {
    params = `?${params}`
  }
  return params
}

export const getRetailerAccount = (action$, state$) => {
  return action$.pipe(
    ofType(actions.GET_RETAILER_ACCOUNT),
    withLatestFrom(state$),
    mergeMap(([action, state]) => {
      const headers = authSelectors.headersSelector(state)
      const {
        id,
        fields = ['retailers', 'retailers.brand', 'retailers.brand.settings'],
      } = action.payload

      if (!headers) {
        throw new Error('Bad or Non-existent auth headers')
      }

      if (!id) {
        throw new Error('payload.id is required')
      }

      const params = buildRetailerAccountParams({ fields })

      const settings = {
        method: 'GET',
        responseType: 'json',
        headers,
        url: `${Config.API_BASE}/v2/retailer_accounts/${id}${params}`,
      }
      return ajax(settings).pipe(
        map((payload) => {
          return {
            type: actions.GET_RETAILER_ACCOUNT_FULFILLED,
            payload: {
              response: payload.response,
            },
            meta: {
              id,
              fields,
            },
          }
        }),
        catchError((payload) => {
          return of({
            type: actions.GET_RETAILER_ACCOUNT_REJECTED,
            payload: payload.response,
            meta: {
              id,
              fields,
            },
          })
        }),
      )
    }),
    catchError((payload) => {
      return of({
        type: actions.GET_RETAILER_ACCOUNT_REJECTED,
        payload,
      })
    }),
  )
}

export const getAllocationDetails = (action$, state$) => {
  return action$.pipe(
    ofType(actions.GET_ALLOCATION_DETAILS),
    withLatestFrom(state$),
    mergeMap(([action, state]) => {
      const headers = authSelectors.headersSelector(state)
      const { id } = action.payload

      if (!headers) {
        throw new Error('Bad or Non-existent auth headers')
      }

      const settings = {
        method: 'GET',
        responseType: 'json',
        headers,
        url: `${Config.API_BASE}/v2/retailer_accounts/${id}/allocation_details`,
      }
      return ajax(settings).pipe(
        map((payload) => {
          return {
            type: actions.GET_ALLOCATION_DETAILS_FULFILLED,
            payload: {
              id,
              response: payload.response,
            },
          }
        }),
        catchError((payload) => {
          return of({
            type: actions.GET_ALLOCATION_DETAILS_REJECTED,
            payload: payload.response,
          })
        }),
      )
    }),
    catchError((payload) => {
      return of({
        type: actions.GET_ALLOCATION_DETAILS_REJECTED,
        payload,
      })
    }),
  )
}

export const getRetailerAlerts = (action$, state$) => {
  return action$.pipe(
    ofType(actions.GET_RETAILER_ALERTS),
    withLatestFrom(state$),
    mergeMap(([action, state]) => {
      const headers = authSelectors.headersSelector(state)
      const { id, fields = [] } = action.payload

      if (!headers) {
        throw new Error('Bad or Non-existent auth headers')
      }

      // fields[]=subjectable
      const params = queryString.stringify(
        { fields },
        { arrayFormat: 'bracket' },
      )

      const settings = {
        method: 'GET',
        responseType: 'json',
        headers,
        url: `${Config.API_BASE}/v2/retailer_accounts/${id}/alerts?${params}`,
      }
      return ajax(settings).pipe(
        map((payload) => {
          return {
            type: actions.GET_RETAILER_ALERTS_FULFILLED,
            payload: {
              id,
              response: payload.response,
            },
          }
        }),
        catchError((payload) => {
          return of({
            type: actions.GET_RETAILER_ALERTS_REJECTED,
            payload: payload.response,
          })
        }),
      )
    }),
    catchError((payload) => {
      return of({
        type: actions.GET_RETAILER_ALERTS_REJECTED,
        payload,
      })
    }),
  )
}

export const markAlert = (action$, state$) => {
  return action$.pipe(
    ofType(actions.MARK_ALERT),
    withLatestFrom(state$),
    mergeMap(([action, state]) => {
      const headers = authSelectors.headersSelector(state)
      const { id, status } = action.payload

      if (!headers) {
        throw new Error('Bad or Non-existent auth headers')
      }

      const settings = {
        method: 'PUT',
        responseType: 'json',
        headers: {
          ...headers,
          'Content-Type': 'application/json',
        },
        url: `${Config.API_BASE}/v2/alerts/${id}`,
        body: {
          alert: {
            status,
          },
        },
      }
      return ajax(settings).pipe(
        map((payload) => {
          return {
            type: actions.MARK_ALERT_FULFILLED,
            payload: payload.response,
          }
        }),
        catchError((payload) => {
          return of({
            type: actions.MARK_ALERT_REJECTED,
            payload,
          })
        }),
      )
    }),
    catchError((payload) => {
      return of({
        type: actions.MARK_ALERT_REJECTED,
        payload: payload.response,
      })
    }),
  )
}

export const markAllAlertsAsRead = (action$, state$) => {
  return action$.pipe(
    ofType(actions.MARK_ALL_ALERTS_AS_READ),
    withLatestFrom(state$),
    mergeMap(([action, state]) => {
      const headers = authSelectors.headersSelector(state)
      const { id } = action.payload

      if (!headers) {
        throw new Error('Bad or Non-existent auth headers')
      }

      const settings = {
        method: 'PUT',
        responseType: 'json',
        headers: {
          ...headers,
          'Content-Type': 'application/json',
        },
        url: `${Config.API_BASE}/v2/retailer_accounts/${id}/alerts/all_read`,
      }
      return ajax(settings).pipe(
        map(() => {
          return {
            type: actions.MARK_ALL_ALERTS_AS_READ_FULFILLED,
            payload: {
              id,
            },
          }
        }),
        catchError((payload) => {
          return of({
            type: actions.MARK_ALL_ALERTS_AS_READ_REJECTED,
            payload,
          })
        }),
      )
    }),
    catchError((payload) => {
      return of({
        type: actions.MARK_ALL_ALERTS_AS_READ_REJECTED,
        payload,
      })
    }),
  )
}
